export const getMainLayoutFields = ({
  partner,
  partnerConfig,
  isInstant,
  code,
  isAccountsLoaded,
  urlId,
  provisionId,
}) => {
  if (partner === 'PAYPAL') {
    return {
      showChildren: isInstant || code,
      showLogoAnimation: !(!code || isAccountsLoaded),
    };
  }
  if (partner === 'AMAZON') {
    if (window && window.opener) {
      return {
        showChildren: true,
        showLogoAnimation: !isAccountsLoaded,
      };
    }
  }
  if (partnerConfig.isPull) {
    if (window && window.opener) {
      return {
        showChildren: true,
        showLogoAnimation: !isAccountsLoaded,
      };
    }
    if (partner === 'BPAY') {
      return {
        showChildren: provisionId,
        showLogoAnimation: !(!provisionId || isAccountsLoaded),
      };
    }
    return {
      showChildren: urlId,
      showLogoAnimation: !(!urlId || isAccountsLoaded),
    };
  }
  return {
    showChildren: false,
    showLogoAnimation: true,
  };
};
